import * as React from 'react'
import {observer} from 'mobx-react-lite'
import {BulkEditPropertyProps, MultiOptionBulkEditProperty} from './BulkEditDialogProperties'
import Select, {MultiValue} from 'react-select'

interface BulkEditEnumControlProps {
    property: BulkEditPropertyProps
    shouldBlockCancelConfirmCallback: React.Dispatch<React.SetStateAction<boolean>>
    id?: string
}

interface Suggestion {
    label: string
    value: string
}

function _BulkEditMultiOptionControl(props: BulkEditEnumControlProps) {
    const {property, id, shouldBlockCancelConfirmCallback} = props

    const multiOptionProperty = property as MultiOptionBulkEditProperty

    const options = Array.from(multiOptionProperty)

    const onChange = React.useCallback(
        (newValue: MultiValue<Suggestion>) => {
            if (newValue) {
                multiOptionProperty.selectKeys(newValue.map(v => v.label))
            } else {
                multiOptionProperty.selectKeys([])
            }
        },
        [multiOptionProperty]
    )

    return (
        <Select
            id={id}
            value={multiOptionProperty.selectedOptions}
            isMulti
            isClearable={false}
            name={multiOptionProperty.name}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={onChange}
            options={options}
            onMenuOpen={() => {
                shouldBlockCancelConfirmCallback(true)
            }}
            onMenuClose={() => {
                shouldBlockCancelConfirmCallback(false)
            }}
        />
    )
}

export const BulkEditMultiOptionControl = observer(_BulkEditMultiOptionControl)
